<template>
  <RightSidebar :isActive.sync="isActive" size="large">
    <template #header>
      <img v-if="venue" width="40" :src="venue.logoUrl" class="mr-4" />
      <div v-if="venue">
        <h4>{{ venue.name }}</h4>
        <small>REKOM POS Venue • Edit info in Workspace</small>
      </div>
    </template>

    <template #content>
      <Loading v-if="isLoading" />
      <div v-else>
        <section class="px-6 pt-6 grid grid-cols-4 gap-x-8">
          <SidebarItem label="Currency">
            <vs-select disabled v-model="venue.currency" class="w-full">
              <vs-select-item
                :key="index"
                :value="item.code"
                :text="item.code"
                v-for="(item, index) in currencies"
              />
            </vs-select>
          </SidebarItem>
        </section>

        <vs-divider />

        <section class="px-6 grid grid-cols-4 gap-x-8">
          <SidebarItem label="City" class="col-span-2">
            <vs-input disabled class="w-full" v-model="venue.city" />
          </SidebarItem>

          <SidebarItem label="Street" class="col-span-2">
            <vs-input disabled class="w-full" v-model="venue.street" />
          </SidebarItem>

          <SidebarItem label="VAT Number">
            <vs-input disabled class="w-full" v-model="venue.vatNumber" />
          </SidebarItem>

          <SidebarItem label="Postal Code">
            <vs-input disabled class="w-full" v-model="venue.postalCode" />
          </SidebarItem>

          <vs-divider disabled class="col-span-full" />

          <SidebarItem label="Logo URL" class="col-span-4">
            <vs-input disabled class="w-full" v-model="venue.logoUrl" />
          </SidebarItem>
        </section>
      </div>
    </template>
    <template #footer>
      <vs-button disabled>Save</vs-button>
      <!-- :disabled="!isFormValid" -->
      <vs-button
        type="border"
        color="danger"
        class="ml-6"
        @click="isActive = false"
        >Cancel</vs-button
      >
      <vs-button
        type="filled"
        color="danger"
        class="ml-auto"
        @click="confirmDelete"
        >Delete</vs-button
      >
    </template>
  </RightSidebar>
</template>

<script>
import RightSidebar from "@/components/Custom/RightSidebar.vue";
import SidebarItem from "@/components/Custom/SidebarItem.vue";

export default {
  components: {
    RightSidebar,
    SidebarItem,
  },
  data() {
    return {
      isActive: false,
      isLoading: true,
      currencies: [
        { code: "EUR" },
        { code: "DKK" },
        { code: "NOK" },
        { code: "GBP" },
      ],

      isNewVenue: false,
      venue: null,
    };
  },
  computed: {
    isFormValid() {
      const v = this.venue;
      if (!v) return false;
      // Add more validation rules as required.
      return true;
    },
  },
  methods: {
    async deleteVenue() {
      if (!this.venue) return;
      console.log("Deleting venue:", this.venue);
      await this.$store.dispatch("pos/venues/deleteVenue", this.venue.id);
      this.isActive = false;
    },
    async confirmDelete() {
      if (!this.venue) return;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Delete venue",
        text: `Are you sure you want to delete venue ${this.venue.name}?`,
        accept: this.deleteVenue,
      });
    },
    async show(venueId) {
      this.isNewVenue = false;
      this.isActive = true;
      this.isLoading = true;

      this.venue = await this.$store.dispatch("pos/venues/getVenue", venueId);
      console.log("Showing venue:", this.venue);
      this.isLoading = false;
    },
  },
};
</script>